import { environment } from '../../environments/environment';
import { APP_CONFIG, EnvConfig, EnvKey, Region } from './app-config';

export const REGION_STORAGE_KEY = 'selected_region';

export function resolveEnvKey(): EnvKey {
  if (environment.production === true) return 'prod';
  if (environment.isStaging === true) return 'staging';
  return 'dev';
}

export function readStoredRegion(): Region {
  const raw = typeof localStorage !== 'undefined' ? localStorage.getItem(REGION_STORAGE_KEY) : null;
  return raw === 'CN' ? 'CN' : 'EU';
}

/** Bootstrap-time config lookup (runs before DI is built, used by app.config.ts). */
export function resolveBootstrapConfig(): EnvConfig {
  return APP_CONFIG[resolveEnvKey()][readStoredRegion()];
}
